import store from '@/store'
import axios from 'axios'

export { AxiosError as RequestError } from 'axios'

export const request = axios.create({
  baseURL: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'prodqa' 
    ? '//webapi.lowiro.com' 
    : process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging' 
      ? '//arcwebproxy.low.moe' : 'http://localhost:8000',
  // baseURL: 'http://localhost:8000',
  xsrfCookieName: 'csrf',
  xsrfHeaderName: 'X-CSRF-TOKEN',
  withCredentials: true,
})

request.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && (error.response.status === 401 || error.response.data.error_code === 203)) {
      // await store.dispatch('loadAuthUser')
    }
    throw error
  }
)
